module.exports = __webpack_public_path__ + "static/media/storyboard2.3a36ee1f.gif";